var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "label",
          { staticClass: "text-primary label-status", attrs: { for: "" } },
          [_vm._v("Status")]
        ),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.status,
                expression: "status"
              }
            ],
            staticClass: "form-control",
            attrs: { name: "", id: "" },
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.status = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.changeData
              ]
            }
          },
          [
            _c("option", { attrs: { value: "" } }, [_vm._v("TODOS")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "ABERTO" } }, [_vm._v("Abertos")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "ENVIADO" } }, [_vm._v("Enviado")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "DELETADO" } }, [
              _vm._v("Deletados")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { attrs: { for: "" } }, [_vm._v("De")]),
            _vm._v(" "),
            _c("date-picker", {
              attrs: { config: _vm.datePickerConfig },
              on: { "dp-change": _vm.changeData },
              model: {
                value: _vm.fromDate,
                callback: function($$v) {
                  _vm.fromDate = $$v
                },
                expression: "fromDate"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { attrs: { for: "" } }, [_vm._v("Até")]),
            _vm._v(" "),
            _c("date-picker", {
              attrs: { config: _vm.datePickerConfig },
              on: { "dp-change": _vm.changeData },
              model: {
                value: _vm.toDate,
                callback: function($$v) {
                  _vm.toDate = $$v
                },
                expression: "toDate"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 printer" }, [
        _c("table", { staticClass: "table table-bordered table-striped" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.orderedProdutos, function(produto) {
              return _c("tr", { staticClass: "text-center" }, [
                _c("td", [_vm._v(_vm._s(produto.codigo))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(produto.produto))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(produto.quantidade))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "R$ " + _vm._s(produto.valor.toFixed(2).replace(".", ","))
                  )
                ])
              ])
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center" }, [_vm._v("Código")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Produto")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Quantidade")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Valor")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2334bb46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2334bb46","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor_ranking/Produtos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2334bb46","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor_ranking/Produtos.vue
// module chunks = 2